import React from 'react';
import '../auth.css';
import i18n from '../i18n';
import {connect} from 'react-redux'
import axios from 'axios';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import {reactLocalStorage} from 'reactjs-localstorage';
import { API_BASE_URL } from "../utils/endpoints";

class FormCode extends React.Component
 {
   constructor(props)
    {
       super(props);
       this.state = { user_name: '' };
       this.state={code :''};
       this.state = { password: '' };
       this.state={re_password :''};
   }

   componentWillMount() {
    if( reactLocalStorage.get('lang') ==='ar')
  {
    i18n.changeLanguage('ar');
  }
  else{
    i18n.changeLanguage('en');
  }
  
  
  }

    resetCheckCode=(e)=> {
      e.preventDefault();
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/auth/confirmforgetpassword";
      }
      else
      {
       apiBaseUrl = ip +"/core/user/rest/auth/confirmforgetpassword";
      }
      var data={};
      var headers = {
             'content-type': 'application/json',
             'username': this.state.user_name,
             'code':this.state.code,
             'new_password':this.state.password
             
         }
      axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
      {
      
        if(response.status === 200)
        {
           if(response.data.status === 'success')
           {
             if(response.data.result.message)
             {   
              toast({
                type: 'success',
                title: i18n.t('success.label'),
                description: response.data.result.message,
                animation: 'bounce',
                time: 5000,
               
            });
            window.location="/app"
      
             }

    }
  }
  else
  {
    toast({
      type: 'error',
      title: i18n.t('error.label'),
      description: response.data.result.errorReposne,
      animation: 'bounce',
      time: 5000,
     
  });
  }
})
    }



    onInputChange=(event)=>
    {
      this.setState({user_name:event.target.value});
    }

    onCodeChange=(event)=>
    {
      this.setState({code:event.target.value});
    }
    onPasswordChange=(event)=>
    {
      this.setState({password:event.target.value});
    }

    onRePasswordChange=(event)=>
    {
      this.setState({re_password:event.target.value});
    }

   render () {
   return (
     <div>
     <form className="ui large form border radius">
     <div className="stacked segment border_margin">



 




<div className="reset_check_code" style={{display:'block'}}>
<div className="field">
     <div className="ui fluid left icon input">
     <input placeholder={i18n.t('username.label')}  type="text" value={this.state.user_name} onChange={this.onInputChange}/>
     <i aria-hidden="true" className="user icon"></i>
     </div></div>
     <div className="field">
     <div className="ui fluid left icon input">
     <input placeholder={i18n.t('code.label')} type="text" value={this.state.code} onChange={this.onCodeChange}/>
     <i aria-hidden="true" className="lock icon"></i>
     </div></div>
     <div className="field">
    <div className="ui fluid left icon input">
    <input placeholder={i18n.t('Password.label')} type="Password" value={this.state.password} onChange={this.onPasswordChange}/>
    <i aria-hidden="true" className="user icon"></i>
    </div></div>

      <div className="field">
      <div className="ui fluid left icon input">
      <input placeholder={i18n.t('re_pass.label')} type="Password" value={this.state.re_password} onChange={this.onRePasswordChange}/>
      <i aria-hidden="true" className="lock icon"></i>
      </div></div>

    <button className="ui large fluid button btn_login radius" onClick={this.resetCheckCode.bind(this)}>{i18n.t('Check_code.label')}</button>
</div>







<SemanticToastContainer/>

     </div>
     </form>
     </div>
          );
      }
   }


const mapStateToProps = (state)=>{
  return {...state}
}

export default connect(mapStateToProps)(FormCode);




